export default __webpack_public_path__ + "static/media/sr.e61ee3f6.jpg";